import { render, staticRenderFns } from "./MsgErroFormularios.vue?vue&type=template&id=46fd8761&scoped=true&"
import script from "./MsgErroFormularios.vue?vue&type=script&lang=js&"
export * from "./MsgErroFormularios.vue?vue&type=script&lang=js&"
import style0 from "./MsgErroFormularios.vue?vue&type=style&index=0&id=46fd8761&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd8761",
  null
  
)

export default component.exports